// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { Box } from '@styleseat/ui';
import { JoinEntryProps } from './types';
import { JoinEntryCardCarousel } from './JoinEntryCardCarousel';
import { useResponsiveEffect } from '../../../../hooks';
import {
  BodyText,
  ImageBox,
  Stack,
} from '../../../ui';
import { getWidth, listenToWidth } from '../../../../modules/Responsive';
import { ImageSizes, MannyImage } from './constants';
import { JoinEntryHeader } from './JoinEntryHeader';

export const JoinEntry = ({
  testID = 'join-entry-component',
  cards,
  onClick = () => {},
}: JoinEntryProps) => {
  const breakpoints = useResponsiveEffect();
  const [width, setWidth] = useState(getWidth);

  const isDefinitelyMobile = breakpoints.mobile || breakpoints.mobileNarrow || width <= 430;
  const isMobileOrTablet = breakpoints.mobile || breakpoints.tablet;
  const isIpadWidthIsh = !breakpoints.mobile && width > 668;
  const isIpadWidthOrLess = width <= 1206;
  const isWide = (breakpoints.desktop || breakpoints.wide) && !isIpadWidthOrLess;
  const titleAlignmentBreak = width >= 1120;
  const isTablet = breakpoints.tablet || breakpoints.desktopNarrow;

  let boxHeight = '630px';

  if (breakpoints.tablet && width > 430) {
    boxHeight = '470px';
  } else if (breakpoints.desktop) {
    boxHeight = '424px';
  }

  let imageProps;
  if (isDefinitelyMobile) {
    imageProps = MannyImage[ImageSizes.Phone];
  } else if (width <= 520 && width >= 402) {
    imageProps = MannyImage[ImageSizes.TabletNarrow];
  } else if (isTablet) {
    imageProps = MannyImage[ImageSizes.Tablet];
  } else {
    imageProps = MannyImage[ImageSizes.Desktop];
  }
  const {
    imageUrl, height: imageHeight, width: imageWidth,
  } = imageProps;

  useEffect(() => {
    const handleResize = newHeight => setWidth(newHeight);
    return listenToWidth(handleResize);
  });

  return (
    <Box
      minHeight={boxHeight}
      borderRadius={8}
      paddingX={0}
      paddingTop={20}
      paddingBottom={isDefinitelyMobile ? 40 : 20}
      alignItems={isWide ? 'flex-end' : undefined}
      style={{
        // @ts-ignore
        background: 'radial-gradient(46.9% 47.59% at 25.29% 59.33%, #FBFAF1 0%, #EEECDC 15.1%, #D1CEAE 100%)',
        marginTop: isDefinitelyMobile || isTablet ? 0 : 44,
        marginLeft: isWide ? 48 : 24,
        marginRight: isWide ? 48 : 24,
      }}
    >
      <ImageBox
        height={imageHeight}
        width={imageWidth}
        sourceURL={imageUrl}
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
        accessibilityLabel="photograph of Manny Espinoza"
      />
      {titleAlignmentBreak && (
        <Stack
          testID={`${testID}-caption-styleseat-artist`}
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            paddingLeft: 20,
            paddingBottom: 28,
          }}
        >
          <BodyText style={{
            fontWeight: 'bold',
          }}
          >Manny Espinoza
          </BodyText>
          <BodyText>Makeup Artist</BodyText>
        </Stack>
      )}
      {isDefinitelyMobile && (
        <Stack
          style={{
            position: 'absolute',
            right: '15%',
            top: '54%',
          }}
        >
          <BodyText style={{
            fontWeight: 'bold',
          }}
          >Manny Espinoza
          </BodyText>
          <BodyText>Makeup Artist</BodyText>
        </Stack>
      )}
      <Stack
        height="100%"
        width={isWide ? '70%' : undefined}
        flex={1}
      >
        <Box
          alignItems={titleAlignmentBreak ? 'center' : 'flex-end'}
        >
          <JoinEntryHeader
            testID={testID}
            onClick={onClick}
            isMobileOrTablet={isMobileOrTablet}
            breakpoints={breakpoints}
            titleAlignmentBreak={titleAlignmentBreak}
            isIpadWidthOrLess={isIpadWidthOrLess}
            deviceWidth={width}
          />
        </Box>
        <Box
          alignItems={isIpadWidthIsh ? 'center' : undefined}
          width="100%"
          paddingTop={breakpoints?.tablet || breakpoints?.desktopNarrow ? 64 : 0}
          style={{
            marginTop: 'auto',
          }}
          testID={`${testID}-carousel-box-container`}
        >
          <JoinEntryCardCarousel
            screenWidth={width}
            cards={cards}
            testID={`${testID}-carousel`}
            breakpoints={breakpoints}
          />
        </Box>

      </Stack>

    </Box>
  );
};
